import { Bundle } from "../../types/Bundle"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fromStrapiBundle = (strapiData: any): Bundle => {
    const { name, code, content, shouldShowInstitutionalFieldsInSignup, paymentOptions, NTUCPrice, clubPrice, bundleExtraPrice, numberOfYears, startDate, endDate } = strapiData

    return {
        name,
        code,
        content,
        shouldShowInstitutionalFieldsInSignup,
        paymentOptions,
        NTUCPrice,
        clubPrice,
        bundleExtraPrice,
        numberOfYears,
        startDate: new Date(startDate),
        endDate: new Date(endDate),
    }

}

export { fromStrapiBundle }